import React, { useEffect, useState } from 'react';
import { FlowerIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type HeaderProps = {
  onCTA: () => void;
};
export function Header({
  onCTA
}: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-crema/95 shadow-sm backdrop-blur-md' : 'bg-crema/70 backdrop-blur-sm'}`} data-id="element-58" data-mp="2wkgri2t5v8w6">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-59" data-mp="36as5yjah10hb">
        <a href="#inicio" className="flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded-lg" data-id="element-60" data-mp="3baodutmahc25">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rosa/15" data-id="element-61" data-mp="3f9dm67sh03ex">
            <FlowerIcon className="h-5 w-5 text-rosa-dark" strokeWidth={1.6} data-id="element-62" data-mp="2rlrhramv5eyu" />
          </span>
          <span className="leading-tight" data-id="element-63" data-mp="2ro48odalmzo1">
            <span className="block font-serif text-base font-semibold text-tinta sm:text-lg" data-id="element-64" data-mp="2mnpz2qtcnhnw">
              Cambio Hormonal
            </span>
            <span className="block text-[10px] uppercase tracking-[0.2em] text-dorado sm:text-xs" data-id="element-65" data-mp="2hpoj4er7zygn">
              El Método del 1%
            </span>
          </span>
        </a>
        <CTAButton onClick={onCTA} className="hidden sm:inline-flex" data-id="element-66" data-mp="3acrdqvsrzp1m">
          Quiero mi app ahora
        </CTAButton>
        <CTAButton onClick={onCTA} className="sm:hidden !px-4 !py-2.5 !text-xs" data-id="element-67" data-mp="35jg3ekor8q4y">
          Quiero mi app
        </CTAButton>
      </div>
    </header>;
}